import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesViewRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-view',
	path: '/secure/project/ViewProjectRoles([!%]?[\\w]*).jspa',
};
